<div class="d-inline-flex">
  <div class="plus-icon">
    <co-image width="24" height="24" type="svg" key="add" imageSet="green"></co-image>
  </div>
  <div class="product-button">
    <co-image width="32" height="32" type="svg" key="sticky"></co-image>
  </div>
</div>